export const SaaSContractColumns = [
    { headerName: 'Empresa', field: 'company.name', width: '240' },
    { headerName: 'Plano', field: 'plan.name', width: '200' },
    { headerName: 'Status', field: 'contractStatus', width: '150' },
    { headerName: 'Assinatura Asaas', field: 'providerSubscriptionId', width: '220' },
    { headerName: 'Próximo vencimento', field: 'nextDueDate', type: 'date', width: '180' },
    // Sem estas duas colunas, o operador não distingue quem está liberado por decisão
    // comercial de quem está pagando em dia: as duas situações aparecem como acesso normal.
    { headerName: 'Isento até', field: 'exemptUntil', type: 'date', width: '150' },
    { headerName: 'Motivo da isenção', field: 'exemptionReason', width: '260' },
];
